import React from 'react'
import grn from '../Assets/green_bg.png'
import red from '../Assets/red_bg.png'
import n5 from '../Assets/n5_bg.png'
import n0 from '../Assets/n0_bg.png'

const Ball = ({ i }) => {
  return (
        <div className='flex flex-col justify-center items-center'>

        <div className='container'>
          { i % 2 !== 0 && i !== 5 && <img className='image max-w-[18px] max-h-[18px]' src={grn} alt='' />}      
          { i % 2 === 0 && i !== 0 && <img className='max-w-[18px] max-h-[18px]' src={red} alt=''/>}
          { i === 0 && <img className='max-w-[18px] max-h-[18px]' src={n0} alt=''/>}
          { i === 5 && <img className='max-w-[18px] max-h-[18px]' src={n5} alt=''/>}
          <div className={`number text-[0.875rem] ${i % 2 !== 0 && 'text-green-500'} ${i % 2 === 0  && 'text-red-500'}`}>{i}</div>
        </div>
        </div>
  )
}

export default Ball